import { render } from "./TenderEntity.vue?vue&type=template&id=d00ae968&scoped=true"
import script from "./TenderEntity.vue?vue&type=script&lang=js"
export * from "./TenderEntity.vue?vue&type=script&lang=js"

import "./TenderEntity.vue?vue&type=style&index=0&id=d00ae968&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d00ae968"]])

export default __exports__